import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
//import DataTableExtensions from 'react-data-table-component-extensions';
import "react-data-table-component-extensions/dist/index.css";
//service
import {
  CurrencyDecimalFormat,
  CurrencyLatest,
  formatNumberWithCommasAndDecimal,
} from "../../helper";
import style from "./ewallet.module.scss";
import { Filter } from ".";
import moment from "moment";

function HistorysTable({ ContentData, paginationchange, exportData, loader }) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const Currency = useSelector((state) => state.curr);

  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // Sets the height of the rows
      },
    },
    headCells: {
      style: {
        fontSize: "13px", // Sets the font size of the column header
        fontWeight: "bold", // Sets the font weight of the column header
        paddingLeft: "9px", // Adds some padding to the left of the column header
        // backgroundColor: "#F5F5F5", // Sets the background color of the column header
      },
    },
    cells: {
      style: {
        fontSize: "13px", // Sets the font size of the table cells
        paddingLeft: "16px", // Adds some padding to the left of the table cells
      },
    },
  };
  //  moment(row.transaction_date).format("YYYY-MM-DD HH:mm:ss"),
  const columns = [
    {
      name: t("Common.transactionDate"),
      selector: (row) => row.transaction_date,
      sortable: true,
    },
    {
      name: t("Common.details"),
      selector: (row) => row.details,
      width: "30%",
    },
    {
      name: t("Common.amount"),
      // selector: (row) => row.amount,
      selector: (row) =>
        formatNumberWithCommasAndDecimal(
          row.amount * Currency.value,
          Currency.precision
        ),
      cell: (row) => {
        console.log({ row });
        return (
          <span
            className={
              currentTheme === "theme-dark"
                ? `${style.dark_mode_credit} ${style.badge}`
                : row.type === "credit"
                ? `${style.credit} ${style.badge}`
                : `${style.debit} ${style.badge}`
            }
          >
            {formatNumberWithCommasAndDecimal(
              row.amount * Currency.value,
              Currency.precision
            )}
          </span>
        );
      },
    },
    // {
    //   name: t("Common.tax").toUpperCase(),
    //   selector: (row) => row.tax,
    //   cell: (row) => (
    //     <span className={`${style.balanceAmount} ${style.badge}`}>
    //       {Currency.currentCurr}{" "}
    //       {CurrencyDecimalFormat(
    //         row.tax * Currency.value,
    //         Currency.precision
    //       )}
    //       {/* {Currency.currentCurr} {Number(row.tax).toFixed(2)} */}
    //     </span>
    //   ),
    // },
    // {
    //   name: t("Common.serviceChange").toUpperCase(),
    //   selector: (row) => row.serviceChange,
    //   cell: (row) => (
    //     <span className={`${style.balanceAmount} ${style.badge}`}>
    //        {Currency.currentCurr}{" "}
    //       {CurrencyDecimalFormat(
    //         row.serviceChange * Currency.value,
    //         Currency.precision
    //       )}
    //       {/* {Currency.currentCurr} {Number(row.serviceChange).toFixed(2)}{" "} */}
    //     </span>
    //   ),
    // },
    // {
    //   name: t("Common.amountPayable").toUpperCase(),
    //   selector: (row) => row.amount_payable,
    //   cell: (row) => (
    //     <span className={`${style.balanceAmount} ${style.badge}`}>
    //        {Currency.currentCurr}{" "}
    //       {CurrencyDecimalFormat(
    //         row.amount_payable * Currency.value,
    //         Currency.precision
    //       )}
    //       {/* {Currency.currentCurr} {Number(row.amount_payable).toFixed(2)}{" "} */}
    //     </span>
    //   ),
    // },
  ];
  const [state, setState] = useState({ data: [] });
  const [date, SetDate] = useState({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
    selectedValues: [],
  });

  const { data } = state;

  useEffect(() => {
    if (ContentData.data) {
      console.log("===content===", ContentData);
      let NewData = ContentData.data.map((resData) => {
        const timeStamp = moment
          .utc(resData.transaction_date)
          .subtract(8, "hours");
        const formattedDate = timeStamp
          .tz("Asia/Manila")
          .format("MM/DD/YYYY h:mm:ss A");
        return {
          // classnameamount : style.credit,
          amount: resData.amount,
          transaction_date: formattedDate,
          // tax: resData.tax,
          type: resData.type,
          details: resData.details,
          //serviceChange: resData.service_charge,
          // amount_payable: resData.amount_payable,
        };
      });
      setState((prev) => ({
        ...prev,
        data: NewData,
      }));
    }
  }, [ContentData]);
  const handlePerRowsChange = (perPage, inPage) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    // let keys = date.selectedValues
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");
    paginationchange(inPage, perPage, date.start, date.end, "", "", keys);
  };
  const handlePageChange = (inPage) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    // let keys = date.selectedValues
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");

    paginationchange(
      inPage,
      ContentData.perPage,
      date.start,
      date.end,
      "",
      "",
      keys
    );
  };
  const handleOnSort = ({ selector }, sortDirection) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    // let keys = date.selectedValues
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");

    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      date?.start,
      date?.end,

      sortDirection,
      selector,
      keys
    );
  };
  const filterHandlet = (start, end, type = "") => {
    SetDate((prev) => ({
      ...prev,
      start: start,
      end: end,
      selectedValues: type,
    }));
    let keys = [];
    type.map((key, idx) => {
      keys.push(key.value);
    });

    // let keys = type
    //   .map((key, idx) => {
    //     return "categories[" + idx + "]=" + key.value;
    //   })
    //   .join("&");
    loader.EarningsTable.search = true;

    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      start,
      end,
      "",
      "",
      keys
    );
  };

  //reset handler
  const resetData = () => {
    SetDate((prev) => ({
      ...prev,
      start: moment().startOf("month").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
    }));

    loader.EarningsTable.reset = true;

    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      moment().startOf("month").format("MMMM D, YYYY"),
      moment().format("MMMM D, YYYY"),
      "",
      "",
      ""
    );
  };
  // const ConvertData =(data) =>{
  //   let newData = data.map((obj)=>{
  //      if(obj.key){
  //       return {
  //         ...obj,
  //         key:t("ewallet."+obj.key)
  //       }
  //     }
  //       else{
  //         return {
  //           ...obj
  //         }
  //       }
  //      })
  //   return newData;

  // }
  return (
    <>
      {/* {ContentData.category.length !== 0 && ( */}

      <Filter
        filterHandler={filterHandlet}
        //type={ConvertData(ContentData.category)}
        resetHandler={resetData}
        isSingle={false}
        exports={true}
        exportData={exportData}
        ContentData={ContentData}
        loader={loader}
      />

      <DataTable
        customStyles={customStyles}
        columns={columns}
        data={data}
        highlightOnHover
        progressPending={ContentData.pending}
        progressComponent={<div>Loading</div>}
        persistTableHead
        noHeader
        pagination
        paginationServer
        responsive
        paginationTotalRows={ContentData.totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        noDataComponent={t("Common.noDataRecordsToDisplay")}
        //onSort={handleOnSort}
      />
      {/* </DataTableExtensions> */}
    </>
  );
}

export default HistorysTable;
